import { useEffect, useState } from 'react';
import { getPracticeInfo, type PracticeInfo } from '../api/bookingApi';

/**
 * Branding + phone for a practice, fetched lazily. The same inline effect lives
 * in App.tsx / KioskPage; those are not migrated here.
 */
export function usePracticeInfo(
  clientId: string | null | undefined,
  enabled = true,
): { info: PracticeInfo | null; loading: boolean; error: string | null } {
  const [info, setInfo] = useState<PracticeInfo | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!enabled || !clientId) return undefined;
    let cancelled = false;
    setLoading(true);
    getPracticeInfo(clientId)
      .then((d) => { if (!cancelled) setInfo(d); })
      .catch((err: Error) => { if (!cancelled) setError(err.message || 'Could not load practice information.'); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [clientId, enabled]);

  return { info, loading, error };
}
